import { Divider, Stack } from '@ltvco/refresh-lib/theme';
import { titleize } from '@ltvco/refresh-lib/utils';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import WorkIcon from '@mui/icons-material/Work';

import {
  ChevronButton,
  TeaserAvatar,
  TeaserDetailLabel,
  TeaserDetailRow,
  TeaserDetailValue,
  TeaserInfo,
  TeaserItemContainer,
  TeaserItemRow,
  TeaserName,
} from '../components';

import type { ContactSearchData } from 'components/DeepSearch/types';

interface ContactSearchPreviewCardProps {
  data: ContactSearchData;
  onTeaserClick?: (
    displayName: string,
    idType: string,
    idValue: string
  ) => void;
}

export const ContactSearchPreviewCard = ({
  data,
  onTeaserClick,
}: ContactSearchPreviewCardProps) => {
  if (!data.teasers.length) {
    return null;
  }

  return (
    <Stack divider={<Divider />}>
      {data.teasers.map((teaser, index) => {
        const displayName = titleize(teaser.name);
        return (
          <TeaserItemContainer
            key={teaser.sourceId || index}
            onClick={() =>
              onTeaserClick?.(displayName, 'source_id', teaser.sourceId)
            }
          >
            <TeaserItemRow>
              <TeaserAvatar>
                <WorkIcon fontSize="small" />
              </TeaserAvatar>
              <TeaserInfo>
                <TeaserName variant="body1">
                  {titleize(teaser.name.toLowerCase())}
                </TeaserName>
                <TeaserDetailRow>
                  <TeaserDetailLabel variant="body2">
                    Job Title:
                  </TeaserDetailLabel>
                  <TeaserDetailValue variant="body2">
                    {teaser.job ? titleize(teaser.job.toLowerCase()) : '-'}
                  </TeaserDetailValue>
                </TeaserDetailRow>
                <TeaserDetailRow>
                  <TeaserDetailLabel variant="body2">
                    Locations:
                  </TeaserDetailLabel>
                  <TeaserDetailValue variant="body2">
                    {teaser.location
                      ? titleize(teaser.location.toLowerCase())
                      : '-'}
                  </TeaserDetailValue>
                </TeaserDetailRow>
              </TeaserInfo>
              <ChevronButton>
                <ChevronRightIcon fontSize="small" />
              </ChevronButton>
            </TeaserItemRow>
          </TeaserItemContainer>
        );
      })}
    </Stack>
  );
};
